import axios from "axios";
export const api = axios.create({
    baseURL: "/api/v1",
    withCredentials: true,
    headers: { "X-Requested-With": "BackupHub" },
});
api.interceptors.response.use((resp) => resp, (error) => {
    if (error.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
    }
    return Promise.reject(error);
});
